module.exports = __webpack_public_path__ + "static/media/afl-mobile.590e51e1.jpg";